import driving from '@disy/cadenza-icons/driving.svg';
import drivingHeavy from '@disy/cadenza-icons/driving-heavy.svg';
import cycling from '@disy/cadenza-icons/cycling.svg';
import foot from '@disy/cadenza-icons/foot.svg';
import wheelchair from '@disy/cadenza-icons/wheelchair.svg';
import h from 'hyperscript';
import avoidance
  from '@disy/cadenza-icons/routing-mini-legend-avoid-polygons.svg';

import { icon } from 'cadenza/utils/icon/icon';

const ICONS_BY_PROFILE_NAME = {
  DRIVING_CAR: driving,
  DRIVING_HGV: drivingHeavy,
  CYCLING_REGULAR: cycling,
  FOOT_WALKING: foot,
  WHEELCHAIR: wheelchair
};

export function getIconForProfile (profileName) {
  return icon(ICONS_BY_PROFILE_NAME[profileName]);
}

export function renderAvoidanceCount (avoidanceCount) {
  return avoidanceCount
    ? h('span.avoidanceCount', [ icon(avoidance), h('span', avoidanceCount) ])
    : null;
}
